import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide, colums" maskId="round-filled-radius-0-stroke-1.5-IconColumnWide"><path d="M11.25 4H2.75C2.33579 4 2 4.33579 2 4.75V19.25C2 19.6642 2.33579 20 2.75 20H11.25V4Z" fill="currentColor"/><path d="M12.75 20H21.25C21.6642 20 22 19.6642 22 19.25V4.75C22 4.33579 21.6642 4 21.25 4H12.75V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWide;
